import Vue from 'vue';
import axios from 'axios';
import L, { control as lControl } from "leaflet";
import reading from '../../../../components/reading';

export default {
  name: 'editReadingMap',
  components: {
    editReadingComp: require('@/employee/captureMeterReadings/editReading.vue').default,
    backButton: require('@/components/backButton/backButton.vue').default,
  },
  props: {
    parent: {
      type: Object
    },
    bigMap: {
      type: Boolean,
      default: true,
    },
    displayCheckReading: {
      type: Boolean,
      default: true,
    }
  },
  data: function () {
    return {
      gisSettings: {},
      currentLocation: {
        lat: 0,
        lng: 0
      },
      mapSettings: {
        map: null,
        zoom: 18,
        center: [],
        isRendering: false
      },

      currLocIcon: null,
      currentLocMarker: null,
      currentLocCircle: null,
      showMap: true,
      showInfoTable: true,
    }
  },
  watch: {
    editReadingDataObj: function (val) {
      if (val)
        this.markCurrentReading();
    },
  },
  computed: {
    getInfoClass: function () {
      return this.showInfoTable ? "map-button-info-icon-on" : "map-button-info-icon-off";
    },
    selectedLocation: function () {
      if (!this.parent.editingReading.connectionGpsX || !this.parent.editingReading.connectionGpsY)
        return { connectionGpsX: 0, connectionGpsY: 0 };
      else
        return { connectionGpsX: this.parent.editingReading.connectionGpsX, connectionGpsY: this.parent.editingReading.connectionGpsY };
    },
    hasSelectedLocation: function () {
      if (this.selectedLocation == null
        || ((this.selectedLocation.connectionGpsX == 0 || this.selectedLocation.connectionGpsX == '') && (this.selectedLocation.connectionGpsY == 0 || this.selectedLocation.connectionGpsY == '')))
        return false;
      else
        return true;
    },
    hasCurrentLocation: function () {
      if (this.currentLocation == null || (this.currentLocation.lng == 0 && this.currentLocation.lat == 0))
        return false;
      else
        return true;
    },
    mapCss: function () {
      return this.bigMap ? 'height-600' : 'height-300';
    }
  },
  beforeUnmount() {
  },
  mounted() {
    let temp = this.$localStorage.get('_map_info');
    this.showInfoTable = temp === 'false' ? false : true;
  },
  created() {
    this.$root.$on('update_selected_marker', this.markCurrentReading);
    this.$root.$on('redraw_map', this.drawConnectionsMarkers);
    
    navigator.geolocation.getCurrentPosition(this.getStartLocation, (err) => console.log(err));
  },
  methods: {
    getTopCss(item) {
      if (item == 'info')
        return this.bigMap ? 'top-490' : 'top-200';
      else
        return this.bigMap ? 'top-540' : 'top-250';
    },
    showInfo() {
      this.showInfoTable = !this.showInfoTable;
      this.$localStorage.set('_map_info', this.showInfoTable);
    },
    getStartLocation(position) {
      this.currentLocation.lat = position.coords.latitude;
      this.currentLocation.lng = position.coords.longitude;

      this.currLocIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/currentLocationMarker.png'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      this.mapSettings.center.push(position.coords.latitude, position.coords.longitude);
      this.getGisSettings();
    },
    getCurrentLocation(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      if (lat == this.currentLocation.lat && lng == this.currentLocation.lng)
        return;

      this.currentLocation.lat = lat;
      this.currentLocation.lng = lng;

      this.mapSettings.map.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt == 'CurrentLocation')
            this.mapSettings.map.removeLayer(layer);
        }
      });

      L.marker([lat, lng], {
        icon: this.currLocIcon,
        alt: 'CurrentLocation'
      }).addTo(this.mapSettings.map);
    },
    getGisSettings() {
      axios.post('/gis/GetGisSettings')
        .then(response => {
          this.gisSettings = response.data;
          this.initMap();
        })
        .catch(error => {
          console.log(error);
        });
    },
    initMap() {
      this.mapSettings.map = L.map(this.$refs.map)
        .setView(this.mapSettings.center, this.mapSettings.zoom);

      let google = L.tileLayer('http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}',
        {
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
          attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );;

      let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );

      let googleEarth = L.tileLayer('https://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}',
        {
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
          attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );


      //default choice
      googleEarth.addTo(this.mapSettings.map);

      //remove leaflet attribution
      this.mapSettings.map.attributionControl.setPrefix('');

      this.currentLocMarker = L.marker([this.currentLocation.lat, this.currentLocation.lng], {
        icon: this.currLocIcon,
        alt: 'CurrentLocation'
      }).addTo(this.mapSettings.map);

      //add all layers to map - overlayes not implemented
      (lControl.layers({
        OpenStreetMap: osm,
        "Google Map": google,
        "Google Earth": googleEarth,
      }) as any).addTo(this.mapSettings.map);


      setInterval(() => {
        navigator.geolocation.getCurrentPosition(this.getCurrentLocation);
      }, 5000);

      this.mapSettings.map.on('moveend', this.loadOnMove);
      this.drawConnectionsMarkers();
    },
    loadOnMove() {
      this.mapSettings.isRendering = false;
      this.drawConnectionsMarkers();
    },
    async drawConnectionsMarkers() {

      if (this.mapSettings.isRendering)
        return;

      this.mapSettings.isRendering = true;
      const bounds = this.mapSettings.map.getBounds();

      const readings = this.filterReadingsByBounds(this.parent.filteredReadings, bounds);

      this.clearReadingsMarkers();

      const blueIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-blue.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const blueIconOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-off-blue.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const greenIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-green.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const greenIconOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-off-green.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const grayIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-gray.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const grayIconOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-off-gray.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const redIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-red.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const redIconOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-off-red.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const blueIconSync = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-blue.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const blueIconSyncOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-off-blue.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const greenIconSync = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-green.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const greenIconSyncOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-off-green.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const grayIconSync = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-gray.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const grayIconSyncOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-off-gray.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const redIconSync = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-red.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const redIconSyncOff = L.icon({
        iconUrl: require('@/assets/images/meterReadings/sync-off-red.svg'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });


      while (this.mapSettings.isRendering) {
        for (let i = 0; i < readings.length; i++) {

          await this.sleep(1);
          let ic = blueIcon;

          let isDisconnected = readings[i].connectionStatus == 2 || readings[i].connectionStatus == 3;     


          //Selected reading
          if (readings[i].connectionGpsY == this.parent.editingReading.connectionGpsY && readings[i].connectionGpsX == this.parent.editingReading.connectionGpsX) {
            //read/posted icon
            if ((readings[i].readingDiscrepancyType >= 3 && readings[i].readingDiscrepancyType <= 17)
              || readings[i].readingDiscrepancyType == 0
              || readings[i].readingDiscrepancyType == 1
              || readings[i].status == 3) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? redIconSyncOff : redIconSync;
              else
                ic = isDisconnected ? redIconOff : redIcon;
            }

            //unread icon
            if (readings[i].readingDiscrepancyType == 2) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? redIconSyncOff : redIconSync;
              else
                ic = isDisconnected ? redIconOff : redIcon;
            }

            //completed icon
            if (readings[i].status == 3) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? redIconSyncOff : redIconSync;
              else
                ic = isDisconnected ? redIconOff : redIcon;
            }
          }
          else {
            //read/posted icon
            if ((readings[i].readingDiscrepancyType >= 3 && readings[i].readingDiscrepancyType <= 17)
              || readings[i].readingDiscrepancyType == 0
              || readings[i].readingDiscrepancyType == 1
              || readings[i].status == 3) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? blueIconSyncOff : blueIconSync;
              else
                ic = isDisconnected ? blueIconOff : blueIcon;
            }

            //unread icon
            if (readings[i].readingDiscrepancyType == 2) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? grayIconSyncOff : grayIconSync;
              else
                ic = isDisconnected ? grayIconOff : grayIcon;
            }

            //completed icon
            if (readings[i].status == 3) {
              if (readings[i].checkReading && this.displayCheckReading)
                ic = isDisconnected ? greenIconSyncOff : greenIconSync;
              else
                ic = isDisconnected ? greenIconOff : greenIcon;
            }     
          }
          

          const marker = L.marker([readings[i].connectionGpsY, readings[i].connectionGpsX], {
            icon: ic,
            alt: readings[i]
          }).addTo(this.mapSettings.map);

          marker.on('click', (event) => {
            //console.log(event.target.options.alt.sequence);
            this.$root.$emit('selected_reading_changed', event.target.options.alt.numbering);
            this.markCurrentReading();
          });
        }
        
        this.mapSettings.isRendering = false;
      }

      this.markCurrentReading();
    },
    markCurrentReading() {
      this.mapSettings.map.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt !== 'CurrentLocation') {
            var icon = layer.options.icon;

            if (layer.options.alt['sequence'] == this.parent.editingReading.sequence) {
              icon.options.iconSize = [50, 50];
              icon.options.iconAnchor = [20, 50];
              icon.options.popupAnchor = [20, -50];
              
              //this.selectedLocation = layer.getLatLng();

            } else {
              icon.options.iconSize = [32, 32];
              icon.options.iconAnchor = [16, 32];
              icon.options.popupAnchor = [16, -32];
            }
            layer.setIcon(icon);
          }
        }
      });
    },
    filterReadingsByBounds(readings, bounds) {
      return readings.filter(reading => {
        const mark = L.latLng(reading.connectionGpsY, reading.connectionGpsX);
        const readingBounds = L.latLngBounds(mark, mark);
        return bounds.intersects(readingBounds);
      });
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm)
      })
    },
    clearReadingsMarkers() {
      this.mapSettings.map.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt !== 'CurrentLocation') {
            this.mapSettings.map.removeLayer(layer);
          }
        }
      });
    },
    centerMap() {
      if (this.hasSelectedLocation)
        this.mapSettings.map.panTo(L.latLng([this.parent.editingReading.connectionGpsY, this.parent.editingReading.connectionGpsX])).setZoom(19);
    },
  }
}
